import React from 'react';
import redraft from 'redraft';
import LazyLoad from 'react-lazyload';
import { MetricsElement } from 'react-metrics';

import HyperLink from '../../shared/components/hyperlink';
import Link from '../../ui/components/link';
import Icon from '../../ui/components/icon';
import Button from '../../ui/components/button';
import ConditionalWrapper from '../../shared/components/conditional-wrapper';
import AdaptiveImage from '../../shared/components/adaptive-image';
import ResponsiveProductCarousel from '../../product/components/responsive-product-carousel';
import ProductCarousel from '../../product/components/product-carousel';
import ProductCarouselCard from '../../blog/components/product-carousel/product-carousel-card';
import DynamicProductCarousel from '../../product/components/dynamic-product-carousel';
import CountDownTimer from '../../shared/components/countdown';
import { Helpers } from '../../core/src/helpers';

import '../css/link-decorator.less'
import '../css/rich-content.less';

class RichContent extends React.PureComponent{

    constructor(){
      super();
      this.getRenderers = Helpers.memoize(
        this.getRenderers,
        (props) => props && props.richContentUniqueIdentifier && props.customRenderer ? props.richContentUniqueIdentifier : null       
      )
    }

    preventRightClick = (event) => {
        if (event.preventDefault)
            event.preventDefault();
        if (event.stopPropagation)
            event.stopPropagation();
        return false;
    }

    // used for blogs only
    getV2CarouselProps = (key) => {

      let wrapperClassName =`blog-product-carousel-${key}`;
      let distance;
      return {
        renderBottomCenterControls: true,
        slideWidth: "321px",
        initialSlideHeight: "482px",
        wrapperClassName,
        getSlideConfig: ({productSkus, customBreakpoints}) => {
          let length =productSkus instanceof Array
                 ? productSkus.filter( r => r && r.active).length
                 : null;
          let stellarGrid = customBreakpoints && customBreakpoints['stellar-grid'];
          let customSlideCount, slidesToShow;
          switch(stellarGrid){
            case 'xlarge':
              customSlideCount = length - (length > 5 ? 4 : length); // extra large - 5 per slide
              slidesToShow = 5;
              break;
            case 'large':
              customSlideCount = length - (length > 4 ? 3 : length); // large - 4 per slide
              slidesToShow = 4;
              break;
            case 'medium':
              customSlideCount = length - (length > 3 ? 2 : length) // medium - 3 per slide
              slidesToShow = 3;
              break;
            case 'small':
              customSlideCount = length - (length > 2 ? 1 : length) // small - 2 per slide
              slidesToShow = 2;
              break;
            case 'xsmall':
              customSlideCount = length;// extra small - 1 per slide
              slidesToShow=1;
          }

          return {
            customSlideCount,
            slidesToShow
          };
        },
        getClassName: ({productSkus, customBreakpoints}) => {
          try{
            distance = distance || (document.querySelector(`.${wrapperClassName}`).getBoundingClientRect().top - document.querySelector('.right-rail-container').getBoundingClientRect().bottom);
            let activeProducts = productSkus instanceof Array ? productSkus.filter(p=>p&& p.active) : [];
            let length = activeProducts && activeProducts.length;
            let stellarGrid = customBreakpoints && customBreakpoints['stellar-grid'];
            let hasNoScroll = stellarGrid && (
                              (stellarGrid === 'xlarge' && length < 6) || 
                              (stellarGrid === 'large' && length < 5) ||
                              (stellarGrid === 'medium' && length < 4) ||
                              (stellarGrid === 'small' && length < 3)
                            );

            let classNames = hasNoScroll ? 'carousel-no-scroll' : null;
            if(distance > 0){
              return `blog-full-carousel${ classNames ? ' ' + classNames : ''}`;
            }
          }catch(e){}
        }
     }
    }

    getRenderers = (props) =>{

      const { overrideNewTab=false, lazyLoadImages, imageMaxWidth, customRenderer, vanityUrl, blogData, linkModifier} = props;
      const { blogMeta, bannerKey } = blogData || {};

      if(customRenderer){
        return customRenderer();
      }
      const fontStyles = {
        BOLD: (children, { key }) => <strong key={key}>{children}</strong>,
        ITALIC: (children, { key }) => <em key={key}>{children}</em>,
        UNDERLINE: (children, { key }) => <u key={key}>{children}</u>,
        SUBSCRIPT: (children, { key }) => <sub style={{fontSize: '0.6em', verticalAlign: 'sub'}} key={key}>{children}</sub>,
        SUPERSCRIPT: (children, { key }) => <sup style={{fontSize: '0.6em', verticalAlign: 'sup'}}  key={key}>{children}</sup>,
      }

      const style={
        padding: '0px',
        margin: '0px',
        display: 'inline-block',
      }

      const renderers = {
        inline: fontStyles,
        blocks: {
            'remove-all-styles': (children, {keys, data}) => {
              let hasData = data instanceof Array;
              const renderedComponent = children.map((child, i) => {
                let blockData = hasData ? data[i] : {};
                let { nestedComponent } = blockData || {};
                return <p className="remove-all-styles" key={keys[i]}>
                                            {child}
                                            {nestedComponent}
                </p>
              });
              return renderedComponent;
            },
            unstyled: (children, {keys, data}) => {
              let hasData = data instanceof Array;
              const renderedComponent = children.map((child, i) => {
                let blockData = hasData ? data[i] : {};
                let { nestedComponent } = blockData || {};
                return <div style={{minHeight: '20px', padding: '0px', margin: '0px', display: 'block', textAlign: 'left', fontSize: '18px'}} key={keys[i]}>
                          {child}
                          {nestedComponent}
                </div>
              })
              return renderedComponent;
            },
            'blockquote': (children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <p style={{padding: '20px 50px', fontSize: '20px', textAlign: 'left', backgroundColor: '#e9e9e9'}} key={keys[i]}>{child}</p>
              });
              return renderedComponent;
            },
            'unordered-list-item': (children, {keys, data}) => {
              let renderedComponent = (
                <ul key={keys} className={"rich-content-unordered-list" + (children.length >= 20 ? " split" : "")}>
                {
                  children.map((child, i) => (
                    <li key={keys[i]} className="list-item">{child}</li>)
                  )
                }
                </ul>
              );
              return renderedComponent;
          },
          'ordered-list-item': (children, {keys, data}) => {
            const renderedComponent = (
              <ol className={"rich-content-ordered-list" + (children.length >= 20 ? " split" : "")}>
              {
                children.map((child, i) => {
                  return (<li key={keys[i]} className="list-item">{child}</li>)
                })
              }
              </ol>
            );
            return renderedComponent;
            },
            'header-one': (children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <h1 style={{textAlign: 'left'}} key={keys[i]}>{child}</h1>
              })
              return renderedComponent;
            },
            'header-two': (children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <h2 style={{textAlign: 'left'}} key={keys[i]}>{child}</h2>
              })
              return renderedComponent;
            },
            'header-three': (children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <h3 style={{textAlign: 'left'}} key={keys[i]}>{child}</h3>
              })
              return renderedComponent;
            },
            'header-four': (children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <h4 style={{textAlign: 'left'}} key={keys[i]}>{child}</h4>
              })
              return renderedComponent;
            },

            'alignTextCenter':(children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <div style={{textAlign: 'center'}} key={keys[i]}>{child}</div>
              })
              return renderedComponent;
            },
            'alignTextLeft':(children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <div style={{textAlign: 'left'}} key={keys[i]}>{child}</div>
              });
              return renderedComponent;
            },
            'alignTextRight':(children, {keys, data}) => {
              const renderedComponent = children.map((child, i) => {
                return <div style={{textAlign: 'right'}} key={keys[i]}>{child}</div>
              })
              return renderedComponent;
            },
            'author-section': (children, {keys, data}) => {
              return (
                <div key={ keys && keys[0]} className="author-section">
                  {
                    children instanceof Array 
                    ? children.map( (block, i) => {
                        return (
                          <div key={i}>
                            {
                              block instanceof Array
                              ? block.map( blockContent => {

                                // checks if it has a new line
                                if(blockContent instanceof Array && typeof blockContent[0] === 'string'){
                                  let modifiedBlock = blockContent.slice();
                                  modifiedBlock[0] = modifiedBlock[0].split('\n')
                                          .map( (segment, blockIdx) => {

                                            return  <div key={blockIdx} style={{display: 'block'}}>
                                                      { blockIdx === 0 && i === 0 && <h2>About the Author</h2> }
                                                      {segment}
                                                    </div>; 
                                          });
                                  return modifiedBlock;
                                }

                                return blockContent;
                              })
                              : block
                          }
                          </div>
                        ); 
                      })
                    : children
                  }
                </div>
              );
            }
        },
        entities: {
            RELATEDARTICLES: (children, data, {key}) => {
              let {relatedArticles} = data || {};
              let {design} = this.props;
              let ulClassName   = design === 'v2' ?  null : "rich-content-unordered-list" + (relatedArticles && relatedArticles.length >= 20 ? " split" : "");
              let header        = design === 'v2' ? 'Related Articles' : 'Related articles:';

              return relatedArticles && relatedArticles.length > 0 && (
                <div key={key} className="related-articles">
                  <h2>{header}</h2>
                  <ul className={ulClassName}>
                    {
                      relatedArticles.map( (relatedArticle, i) => {
                        let {title, link, newTab} = relatedArticle || {};
                        return title && link && (
                          <li key={i} className='list-item'>
                            {
                              design === 'v2'
                              ? <>
                                  <Icon size={20} name="right_small" />
                                  <Link color="dark" to={link} newTab={newTab}>{title}</Link>
                                </>
                              : <HyperLink className="wysiwyg-link" to={link} newTab={newTab}>{title}</HyperLink> 
                            }
                          </li>
                        );
                      })
                    }
                  </ul>
                </div>
              );
            },
            DRAFTJSTABLE: (children, data, {key}) => {
              let {table, title, titleIncluded} = data;
              const TableHead = titleIncluded ? <thead><tr><th className="table-header" colSpan={table.length}>{title}</th></tr></thead> : null;
              
              return (
                <table key={key} className="editor-table">
                  {TableHead}
                  <tbody>
                    {table.map((row, rowIndex)=>(
                      <tr className={"table-row" + (rowIndex % 2 === 0 ? ' even': ' odd')} key={rowIndex}>
                        {row.map((cell, colIndex)=>(
                        <td className={'table-cell' + ' row ' + rowIndex + ' col ' + colIndex} key={colIndex}><p>{cell}</p></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )
            },
            CTABUTTON: (children, data, {key}) => {
              let {cta, url, newtab} = data;
              let { blogKey, design } = this.props;
              let ctaLink = design === 'v2'
                            ? <Button size="large" variation="secondary" color="dark" text={cta} action="go"/>
                            : <span>{cta}</span>
              
              let finalUrl = typeof linkModifier === 'function'
                              ? linkModifier(url)
                              : url;
              
              return (
                <MetricsElement
                  element={'a'}
                  key={key}
                  data-metrics-event-name="linkClick"
                  data-metrics-link-placement='Shop-CTA'
                  data-metrics-event="e_linkClick"
                  data-metrics-link-id={`tech-takes:${blogKey}`}
                  className={design === 'v2' ? "v2-ctabutton" : "ctabutton"}
                  target={newtab && url ? '_blank' : null}
                  href={finalUrl}
                >
                  {ctaLink} 
                </MetricsElement>
              );
            },
            COUNTDOWNTIMER: (children, data, { key }) => {
              let {date} = data
              return <CountDownTimer key={key} endtime={new Date(date).getTime()}/>;
            },
            CUSTOMHTML: (children, data, {key}) => {
              let { customHtml } = data || {};
              return customHtml ? <div key={key} dangerouslySetInnerHTML={{__html: customHtml}} /> : null
            },
            PRODUCTCAROUSEL: (children, data, { key }) => {
              const {productSkus, header} = data;
              let { design } = this.props;
              let carouselProps = {
                header, key, 
                skus: productSkus, 
                render:(key, product) => {
                  const {active} = product;
                  if(active) {
                    return (
                      <ProductCarouselCard key={key} product={product}/>
                    );
                  };
                }
              };

              return design === 'v2'
                    ? <ResponsiveProductCarousel {...carouselProps} {...this.getV2CarouselProps(key)} />
                    : <ProductCarousel {...carouselProps} />;
            },
            DYNAMICPRODUCTCAROUSEL: (children, data, { key }) => {
              const {categories, facets, sort, header} = data || {};
              let { design } = this.props;

              let carouselProps = design === 'v2'
              ? this.getV2CarouselProps(key)
              : {};
              
              return categories || facets ? (
                <DynamicProductCarousel {...carouselProps} isV2={design==='v2'} header={header} key={key} categories={categories} facets={facets} sort={sort} vanityUrl={vanityUrl}/>
              ) : null;
            },
            HOWTO: (children, data, {key,...rest}) => {
              return children;
            },
            HPVIDEO: (children, data, { key }) => {
              const {src, width, autoplay=false} = data;
              const videoProps = {
                key,
                onContextMenu: this.preventRightClick,
                className: width || "full",
                controls:true,
                controlsList:"nodownload"
              }

              if (autoplay) {
                videoProps.autoPlay = "autoPlay",
                videoProps.muted = true;
              }

              return (
                <div className={`video-frame scale-${width || "full"}`} >
              {
                <video
                  {...videoProps}
                >
                <source src={src} type="video/mp4"/>Your browser does not support the video.</video>
              }
              </div>
            )
            },
            YOUTUBEVIDEO: (children, data, { key }) => {
              let {src, width, autoplay=false} = data;
              const videoId = src.split('v=').pop();
              src = `https://www.youtube.com/embed/${videoId}${autoplay ? "?autoplay=1" : ""}`;
                    
              return (
                <ConditionalWrapper
                  condition={!autoplay}
                  wrapper={children => <LazyLoad offset={300} once={true} height={270}>{children}</LazyLoad>} 
                >
                        <div
                    key={key}
                    className={`video-frame scale-${width || "full"}`} >
                    <iframe
                      allow="autoplay"
                      encrypted-media="true"
                      gyroscope="true"
                      picture-in-picture="true"
                      className={width || "full"}
                      src={src}
                      frameBorder="0"
                      allowFullScreen={true}>
                    </iframe>
                  </div>
                </ConditionalWrapper>
              )
            },
            VIMEOVIDEO: (children, data, { key }) => {
              let {src, width, autoplay=false} = data;
              const videoId = src.split('vimeo.com/').pop();

              src = `https://player.vimeo.com/video/${videoId}${autoplay ? "?autoplay=1" : ""}`;
                    
              return (
                <ConditionalWrapper
                  condition={!autoplay}
                  wrapper={children => <LazyLoad offset={300} once={true} height={270}>{children}</LazyLoad>} 
                >
                  <div
                  key={key}
                  className={`video-frame scale-${width || "full"}`} >
                  <iframe
                    allow="autoplay"
                    encrypted-media="true"
                    gyroscope="true"
                    picture-in-picture="true"
                    className={width || "full"}
                    src={src}
                    frameBorder="0"
                    allowFullScreen={true}>
                  </iframe>
                </div>
                </ConditionalWrapper>
              );
            },
            LINK: (children, data, { key }) => {
              let {url, newTab=false} = data;
              if(overrideNewTab) {
                newTab = (/^(https?:)?\/\//i).test(url) ? true : false;
              }

              let linkProps = {
                newTab,
                key,
                to: typeof linkModifier === 'function' ? linkModifier(url) : url
              };
              return <HyperLink className="wysiwyg-link"  {...linkProps}>{children}</ HyperLink>;
            },
            IMAGE: (children, data, { key }) => {
              const { src ="", alt="HPImage", title="HPImage", width=40, alignment, link } =  data;

              let imageAlignment = "rich-content-image";

              if(alignment == "center") {
                imageAlignment += " center";
              }
              else if(alignment == "left") {
                imageAlignment += " left";
              }
              else if(alignment == "right") {
                imageAlignment += " right";
              }
              else {
                imageAlignment += " default";
              }
              const newTab = link && (/^(https?:)?\/\//i).test(link) ? true : false;
              let finalLink = typeof linkModifier === 'function' ? linkModifier(link) : link;
              return <ConditionalWrapper
                        condition={link}
                        wrapper={children => <HyperLink key={key} newTab={newTab} to={finalLink}>{children}</HyperLink>} >
                          <AdaptiveImage 
                            key={`img-${key}`}
                            lazyload={lazyLoadImages} 
                            maxWidth={imageMaxWidth}
                            className={imageAlignment} 
                            src={src} alt={alt} 
                            title={title} 
                            customStyle={{width: width+"%"}}/>
                  </ConditionalWrapper>;
            },
            'draft-js-video-plugin-video':(children, data, { key }) => {
              const {src} = data;
              const videoId = src.split('v=').pop();

              return (
                <div
                key={key}
                className={'video-frame scale-full'}>
                  <iframe
                    className={"full"}
                    src={`https://www.youtube.com/embed/${videoId}`} frameBorder="0" allowFullScreen={true}>
                  </iframe>
                </div>
              )
            }
        },
        decorators: null
      };

      return renderers;
    }

     withBlockModifiers = (renderers, blockMap, blockModifiers) => {
       if(!(blockModifiers instanceof Array) || blockModifiers.length === 0){
          return renderers;
       }

      if(renderers.blocks){
        let prevDepth = 0;
        Object.keys(renderers.blocks).forEach((key, i) => {
          let fn = renderers.blocks[key];
          renderers.blocks[key] = function(){

            let [children, blockData ] = arguments;
            let { keys, data } = blockData;

            try{
              let hasDepth = blockData && blockData.depth > 0;
              let isNotNested = !hasDepth && prevDepth === 0;
              let isDeepestNestedBlock = prevDepth === 0 && hasDepth;
              let isPartOfNestedBlock = prevDepth !== 0; // this indicates in the current iteration that we're evaluating nested blocks
              
              let nextModifiedBlock = blockModifiers.reduce( (modifiedData, nextModifier) => {
                                        return nextModifier(modifiedData) ;
                                      }, data);
              
              // if it's not part of a set of nested block, or it's the deepest nested block, add a new blockData
              // indicating that the data associated with current block isn't part of the previous block.
              // redraft() evaluates the deepest block in a set of nested blocks first before higher blocks.
              if(isNotNested || isDeepestNestedBlock){
                blockMap.push(nextModifiedBlock);
              }
              // when evaluating a block that's part of a set of nested blocks, and it's not the deepest block in the set,
              // the current blockData should be added to the last entry of the blockMap.
              else if(isPartOfNestedBlock){
                nextModifiedBlock = nextModifiedBlock instanceof Array ? nextModifiedBlock : [nextModifiedBlock]
                let lastIndex = blockMap.length > 0 ? blockMap.length - 1 : 0;
                let lastBlock = blockMap[lastIndex];
                lastBlock = lastBlock instanceof Array ? lastBlock : [lastBlock];
                blockMap[lastIndex] = lastBlock.concat(nextModifiedBlock);
              }

              // need to keep track of the previous depth to determine whether to append to blockMap 
              // or just update the last entry. The reason for this is because when redraft() encounters a nested block,
              // it will start with the deepest block first.
              prevDepth = blockData && blockData.depth ? blockData.depth : 0;
            }catch(e){ }

            return fn.apply(this, arguments);
          }
        });
      }
      return renderers;
    }
    /*
        In each iteration of the applyContentModifiers' reduce() call, 'content' and 'blockMap' are arrays, and the current contentModifier() uses these to generate 
        the next content and blockMap evaluated in the next iterations. The array format of 'content' and 'blockMap' must be maintained throughout all iterations in
        order to support multiple contentModifiers. 

        Once all contentModifiers() have been executed, the final
        rendered component is either 'content', or 'content' nested in the wrapper component defined in renderWrappedComponent().
        If at any time the contentModifier() provides a wrapper, renderWrappedComponent() gets updated so it wraps the 
        component it was defined to return in the previous iteration, allowing support for multiple wrappers where preceding wrappers
        are nested in wrappers generated in later iterations. The component returned by renderWrappedComponent() can look something like this
        if multiple wrappers where provided:
          Iteration 1: <wrapper1>{content}</wrapper1>
          Iteration 2: <wrapper2><wrapper1>{content}</wrapper1></wrapper2>
          ...
        
        The difference between renderWrappedComponent() and contentModifier() is that 
        contentModifier() may also wrap several content blocks (entries in the 'content' array) and combine them into a single entry in the array,
        but it must return an array so it can be properly processed in the next contentModifiers().

        
        contentModifier() - takes the 'content' and 'blockMap' array, and returns an updated 'content', 'blockMap', and potentially a 'wrapper'
        renderWrappedComponent() - takes the final 'content' array, and returns a component where 'content' is nested inside a wrapper component.
                                   renderWrappedComponent() is updated per iteration so wrappers generated at a later time is used as the parent
                                   component of the previous wrappers.

        'content' - array of components initially produced by redraft(), and updated through the applyContentModifiers() function to determine final component to render.
        'blockMap' - has meta-data matching each entry of the array. contentModifier() must be responsible for using these data, matching it to an entry in the array
                   and producing a new 'content' array with it.
    */

    applyContentModifiers = (content, blockMap, contentModifiers) => {
      if(!(contentModifiers instanceof Array) || contentModifiers.length === 0) return content;

      let currentBlockMap = blockMap;
      let renderWrappedComponent;
      try{
        let finalContent = contentModifiers.reduce( ( modifiedContent, contentModifier, index) => {
          let { content: updatedContent,
                blockMap: updatedBlockMap,
                wrapper } = contentModifier(modifiedContent, currentBlockMap);
          currentBlockMap = updatedBlockMap;

          if(wrapper && wrapper.component){
            let renderInnerComponent = renderWrappedComponent;
            renderWrappedComponent = (children) => (
              <wrapper.component>{ renderInnerComponent ? renderInnerComponent(children) : children }</wrapper.component> 
            );
          }

          return index === contentModifiers.length-1 && renderWrappedComponent
                 ? renderWrappedComponent(updatedContent)
                 : updatedContent;
        }, content);

        return finalContent;
      }catch(e){
        return content;
      }
    }

    withEntityModifiers = (renderers, entityModifiers, parsed) => {
      if(!(entityModifiers instanceof Array) || entityModifiers.length === 0){
        return renderers;
      }

      if(renderers.entities){
        Object.keys(renderers.entities).forEach((key, i) => {
          let fn = renderers.entities[key];

          renderers.entities[key] = function(){

            let [children, entityData, keys ] = arguments;
            let initialComponent = fn.apply(this, arguments);

            let finalEntityComponent = entityModifiers.reduce( (finalComp, entityModifier) => (
              typeof entityModifier === 'function' 
              ? entityModifier(children, entityData, keys, initialComponent, parsed)
              : finalComp
              ), initialComponent );
            return finalEntityComponent;
          }
        });
      }

      return renderers;
    }

    /**
     * Grabs data directly from the draftjs object.
     */
    applyDataAggregators = (parsedContent, dataAggregators) => {
      try{
        dataAggregators.forEach(dataAggregator => typeof dataAggregator === 'function' && dataAggregator(parsedContent));
      }catch(e){}
    }

    render() {
        let parsed;
        let blockMap = [];
        const {raw, blockModifiers, contentModifiers, entityModifiers, dataAggregators} = this.props;

        if (!raw || typeof raw !== "string") {
          return null;
        }

        // when content is cleared out from draftjs editor and saved
        if (raw === "{}") {
          return null;
        }

        try {
          parsed = JSON.parse(raw);
          this.applyDataAggregators(parsed, dataAggregators);
        } catch(e) {
          //this is for backwards campat, but we may just want to return null
          return typeof parsed === 'string' ? parsed : null;
        }

        let renderers = this.getRenderers(this.props);
        let renderersWithBlockModifier = this.withBlockModifiers(renderers, blockMap, blockModifiers);
        let renderersWithBlockAndEntityModifier = this.withEntityModifiers(renderersWithBlockModifier, entityModifiers, parsed);
        let content =  redraft(parsed, renderersWithBlockAndEntityModifier);

        return (
          <div className='rich-content' style={{display: 'block'}}>
            {
              this.applyContentModifiers(content, blockMap, contentModifiers)
            }
          </div>
        );
    }
}

export default RichContent;

RichContent.propTypes = {
    //raw: PropTypes.string.isRequired
}